import { createSelector } from 'reselect';

import { sortLabels } from 'utils/label';

import { Label } from 'types';

const getLabel = (labels: Label[], labelId: string) => labels.find(label => label.id === labelId);
export const makeGetLabel = () => createSelector(getLabel, labels => labels);

const getLabels = (labels: Label[]) => sortLabels(labels
    .filter(label => label && !label.removed && label.type === 'others'));

export const makeGetLabels = () => createSelector(getLabels, labels => labels);

const getUserLabels = (labels: Label[]) => sortLabels(labels
    .filter(label => label && !label.removed && label.type === 'member'))
export const makeGetUserLabels = () => createSelector(getUserLabels, labels => labels);
